export enum OmsOrderStatusType {
  Pending = "Pending",
  Started = "Started",
  Completed = "Completed",
  Canceled = "Canceled",
  Draft = "Draft",
  OnHold = "OnHold",

  // @deprecated
  NotScheduled = "NotScheduled",
  // @deprecated
  Scheduled = "Scheduled",
  // @deprecated
  Dispatched = "Dispatched",

  PendingCompletionApproval = "PendingCompletionApproval"
}
